import { Button, Checkbox, Form, Input, InputNumber, message, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { CloseCircleOutlined } from "@ant-design/icons";
import { fiscalVids, fiscalizationServices, paymentVidBanks } from "../../extensions/helper";
import { convertFieldsToFloat } from "../../extensions/utils";
import { LogMonitor } from "@/controls";

const PaymentVid = ({ id, onClose }) => {
  const [item, setItem] = useState({ fiscal: 0 });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`paymentvid/${id}`)
        .then(data => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
    else form.setFieldsValue(item);
  }

  useEffect(getData, [id, form])

  const onValuesChange = (value) => {
      setItem({ ...item, ...value });
  }; 

  const onSave = () => {
    setLoading(true)
    const newItem = convertFieldsToFloat(item, ["bankComission", "serviceComission"]);
    serverFetch("paymentvid", { method: id ? "PUT" : "POST", bodyData: newItem })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const onCancel = () => onClose()

  return<div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title"><span>Вид оплаты</span><CloseCircleOutlined className="sport-section-title-close" onClick={onCancel}/></div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
          <Form.Item label=" " className="sport-section-title sport-modal-group-item">Основное</Form.Item>
          <Form.Item label=" " valuePropName="checked" name="active"><Checkbox>Активен</Checkbox></Form.Item>
          <Form.Item label="Наименование" name="name"><Input /></Form.Item>
          <Form.Item label="Вид" name="fiscal"><Select options={fiscalVids} /></Form.Item>
          {item?.fiscal >= 11 && item?.fiscal <= 20 && <>
            <Form.Item label=" " className="sport-section-title sport-modal-group-item">Дополнительные поля</Form.Item>
            <Form.Item label="URL" name="url"><Input /></Form.Item>
            <Form.Item label="Пользователь" name="user"><Input autoComplete="off" /></Form.Item>
            <Form.Item label="Пароль" name="password"><Input.Password autoComplete="new-password" /></Form.Item>
            <Form.Item label="Токен" name="token"><Input /></Form.Item>
            <Form.Item label="Комиссия банка" name="bankComission"><InputNumber style={{ width: '100%' }} min={0} step={0.01} /></Form.Item>
            <Form.Item label="Комиссия сервиса" name="serviceComission"><InputNumber style={{ width: '100%' }} min={0} step={0.01} /></Form.Item>
            <Form.Item label="Банк" name="bank"><Select options={paymentVidBanks} /></Form.Item>
            <Form.Item label=" " className="sport-section-title sport-modal-group-item">Фискализация</Form.Item>
            <Form.Item label="Сервис" name="fiscalizationService"><Select options={fiscalizationServices} /></Form.Item>
            {item?.fiscalizationService === 1 && <>
              <Form.Item label="Магазин" name="fiscalizationShopId"><Input /></Form.Item>
              <Form.Item label="API токен" name="fiscalizationToken"><Input.Password autoComplete="new-password" /></Form.Item>
            </>}
          </>}
          <Form.Item label=" ">
            <Space>
              <Button className="sport-btn" onClick={onSave}>Сохранить</Button>
              <LogMonitor vid={5} id={id}/>
              <Button className="sport-btn" onClick={onCancel}>Закрыть</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </div>
  </div>
}

export default PaymentVid;